// extracted by mini-css-extract-plugin
export default {"home":"c-h_ek","home__content":"c-h_el"};